import * as Yup from 'yup';

import dayjs from 'dayjs';

const parseDateString = (value: any, originalValue: any) => {
  if (value === null || value === '') {
    return new Date();
  }
  const parsedDate = dayjs(originalValue).isValid()
    ? value
    : dayjs(originalValue).format('MMMM DD, YYYY');

  return parsedDate;
};

export const validation = Yup.object({
  speechDate: Yup.date()
    .transform(parseDateString)
    .typeError('Invalid date format. (MMMM DD, YYYY)')
    .required('Field is required'),
  club: Yup.object().nullable()
      .shape({
          name: Yup.string().required('Name is required'),
          id: Yup.number().required('id is required'),
      }).required('Club is Required'),
  evaluator: Yup.object().nullable()
      .shape({
          name: Yup.string().required('Name is required'),
          id: Yup.number().required('id is required'),
      }).required('Evaluator Name is Required'),
  speechTitle: Yup.string().required('Field is required'),
  evaluationForm: Yup.object().nullable()
      .shape({
          name: Yup.string().required('Name is required'),
          id: Yup.number().required('id is required'),
      }).required('Evaluation Form is Required'),
  request: Yup.string(),
});
